import React from 'react'
import SurveryReport from '../../../components/organisms/admin/report/SurveryReport'


type Props = {}

const SurveryReportPage = (props: Props) => {
  return (
    <SurveryReport />
  )
}

export default SurveryReportPage